import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { userResolver } from './resolvers/user.resolver';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'projects',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login-page.component').then(c => c.LoginPageComponent),
  },
  {
    path: 'password-change-request',
    loadComponent: () => import('./pages/password-change-request/password-change-request-page.component').then(c => c.PasswordChangeRequestPageComponent),
  },
  {
    path: 'password-change/:token',
    loadComponent: () => import('./pages/password-change/password-change-page.component').then(c => c.PasswordChangePageComponent),
  },  
  {
    path: 'u',
    loadComponent: () => import('./pages/protected/protected.component').then(c => c.ProtectedComponent),
    canActivate: [authGuard],
    resolve: {
      user: userResolver,
    },
    children: [
      {
        path: 'projects',
        loadComponent: () => import('./pages/protected/project-list/project-list-page.component').then(c => c.ProjectListPageComponent),
      },
      {
        path: 'project',
        loadComponent: () => import('./pages/protected/project-details/project-details-page.component').then(c => c.ProjectDetailsPageComponent),
      },
      {
        path: 'project/:projectId',
        loadComponent: () => import('./pages/protected/project-details/project-details-page.component').then(c => c.ProjectDetailsPageComponent),
      },
      {
        path: 'events',
        loadComponent: () => import('./pages/protected/event-list/event-list-page.component').then(c => c.EventListPageComponent),
      },
      {
        path: 'event',
        loadComponent: () => import('./pages/protected/event-details/event-details-page.component').then(c => c.EventDetailsPageComponent),
      },
      {
        path: 'event/:eventId',
        loadComponent: () => import('./pages/protected/event-details/event-details-page.component').then(c => c.EventDetailsPageComponent),
      },
      {
        path: 'seasons',
        loadComponent: () => import('./pages/protected/season-list/season-list-page.component').then(c => c.SeasonListPageComponent),
      },
      {
        path: 'season',
        loadComponent: () => import('./pages/protected/season-details/season-details-page.component').then(c => c.SeasonDetailsPageComponent),
      },
      {
        path: 'season/:seasonId',
        loadComponent: () => import('./pages/protected/season-details/season-details-page.component').then(c => c.SeasonDetailsPageComponent),
      },
      {
        path: 'clients',
        loadComponent: () => import('./pages/protected/client-list/client-list-page.component').then(c => c.ClientListPageComponent),
      },
      {
        path: 'client',
        loadComponent: () => import('./pages/protected/client-details/client-details-page.component').then(c => c.ClientDetailsPageComponent),
      },
      {
        path: 'client/:clientId',
        loadComponent: () => import('./pages/protected/client-details/client-details-page.component').then(c => c.ClientDetailsPageComponent),
      },
      {
        path: 'elements',
        loadComponent: () => import('./pages/protected/element-list/element-list-page.component').then(c => c.ElementListPageComponent),
      },
      {
        path: 'element',
        loadComponent: () => import('./pages/protected/element-details/element-details-page.component').then(c => c.ElementDetailsPageComponent),
      },
      {
        path: 'element/:elementId',
        loadComponent: () => import('./pages/protected/element-details/element-details-page.component').then(c => c.ElementDetailsPageComponent),
      },
      {
        path: 'element/:elementId/:date_from_to',
        loadComponent: () => import('./pages/protected/element-details/element-details-page.component').then(c => c.ElementDetailsPageComponent),
      },
      {
        path: 'element-types',
        loadComponent: () => import('./pages/protected/element-type-list/element-type-list-page.component').then(c => c.ElementTypeListPageComponent),
      },
      {
        path: 'element-type',
        loadComponent: () => import('./pages/protected/element-type-details/element-type-details-page.component').then(c => c.ElementTypeDetailsPageComponent),
      },
      {
        path: 'element-type/:elementTypeId',
        loadComponent: () => import('./pages/protected/element-type-details/element-type-details-page.component').then(c => c.ElementTypeDetailsPageComponent),
      },
      {
        path: 'element-groups',
        loadComponent: () => import('./pages/protected/element-group-list/element-group-list-page.component').then(c => c.ElementGroupListPageComponent),
      },
      {
        path: 'element-group',
        loadComponent: () => import('./pages/protected/element-group-details/element-group-details-page.component').then(c => c.ElementGroupDetailsPageComponent),
      },
      {
        path: 'element-group/:elementGroupId',
        loadComponent: () => import('./pages/protected/element-group-details/element-group-details-page.component').then(c => c.ElementGroupDetailsPageComponent),
      },
      {
        path: 'element-availability',
        loadComponent: () => import('./pages/protected/element-availability/element-availability-page.component').then(c => c.ElementAvailabilityPageComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/protected/user-list/user-list-page.component').then(c => c.UserListPageComponent),
      },
      {
        path: 'user',
        loadComponent: () => import('./pages/protected/user-details/user-details-page.component').then(c => c.UserDetailsPageComponent),
      },
      {
        path: 'user/:userId',
        loadComponent: () => import('./pages/protected/user-details/user-details-page.component').then(c => c.UserDetailsPageComponent),
      },
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
